import { Injectable } from '@angular/core';
import { BreadCrumbItemI } from 'src/app/shared/shared-interfaces';


@Injectable({
  providedIn: 'root'
})
export class SchedulerBreadcrumbsService {

  getItems() : BreadCrumbItemI[] {
    const items: BreadCrumbItemI[] = [
      {
        title: 'Home',
        text: 'Home',
        path: ['/']
      },
      {
        title: 'Scheduled Jobs',
        text: 'Scheduled Jobs',
        path: ['/admin', 'jobs']
      }
    ];

    return items;
  }
}
